import { useAccount, useMsal } from "@azure/msal-react";
import { useMemo } from "react";

export const useUserFromMsal = () => {
  const { accounts } = useMsal();
  const msalAccount = useAccount(accounts[0]);

  const email = useMemo(() => {
    const email =
      msalAccount?.idTokenClaims?.preferred_username ??
      msalAccount?.username ??
      "";

    if (email?.split("@")[1]?.toLowerCase() === "ikea.com") {
      return email.replace("ikea", "ingka.ikea");
    }

    return email;
  }, [msalAccount]);

  const uid = msalAccount?.idTokenClaims?.oid ?? "";

  return { uid, email };
};
